var _path, _g, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDinersClub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2656A0",
    d: "M69.3638,80.6363C86.2833,80.6363,100,66.9199,100,50.0001c0-16.9197-13.7167-30.6364-30.6362-30.6364 H30.6363C13.7167,19.3637,0,33.0804,0,50.0001c0,16.9198,13.7167,30.6362,30.6363,30.6362H69.3638z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9929 -0.1193 0.1193 0.9929 -5.7484 4.0137)",
    fill: "#FFFFFF",
    cx: 30.6363,
    cy: 50.0001,
    rx: 29.9516,
    ry: 29.9516
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2656A0",
    d: "M24.5904,32.7083c-7.1433,2.4975-12.2674,9.2963-12.2674,17.2918c0,8.0094,5.142,14.8182,12.305,17.3047 L24.5904,32.7083z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2656A0",
    d: "M48.9495,50.0001c0,8.0094-5.1418,14.8182-12.3048,17.3047l0.0376-34.5966 C43.8256,35.2058,48.9495,42.0046,48.9495,50.0001"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "static/media/diners-club.a2b3c84f.svg";
export { ForwardRef as ReactComponent };